import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { PageHeader } from '../common';
import PageBackButton from '../../../components/PageBackButton';

const ExpertDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Box>
      <PageHeader
        title={`Expert #${id}`}
        backButton={<PageBackButton label="Back to Experts" to="/ai/experts" preferHistory={false} hideLabelOnMobile />}
      />
      <Typography>Details for Expert #{id} coming soon...</Typography>
    </Box>
  );
};

export default ExpertDetail;
